export default __webpack_public_path__ + "static/project-slide-7-1640-765-6e5328aaf6e374ce13f524be80fea3df.jpg";